window.dataLayer = window.dataLayer || []

export default {
  sendStartPageView: () => {
    window.dataLayer.push({ event: 'donsignup_start_page_view' })
  },
  sendLearnSaClick: () => {
    window.dataLayer.push({ event: 'donsignup_learn_sa_click' })
  },
  sendAccountSubmitSuccess: () => {
    window.dataLayer.push({ event: 'donsignup_acc_submit_success' })
  },
  sendAccountSubmitFail: () => {
    window.dataLayer.push({ event: 'donsignup_acc_submit_fail' })
  },
  sendAccountAccountConfirmSuccess: () => {
    window.dataLayer.push({ event: 'donsignup_acc_confirm_success' })
  },
  sendAccountAccountConfirmFail: () => {
    window.dataLayer.push({ event: 'donsignup_acc_confirm_fail' })
  },
  sendAccountAccountReauthSuccess: () => {
    window.dataLayer.push({ event: 'donsignup_acc_reauth_success' })
  },
  sendAccountAccountReauthFail: () => {
    window.dataLayer.push({ event: 'donsignup_acc_reauth_fail' })
  },
}
